import { actionTypes } from "../../../actions/ui/routeDetail/selectedParcels";

const initialState = {};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.ON_SELECT_PARCEL:
      const { [payload.parcelCode]: selected, ...rest } = state;

      if (selected) {
        return rest;
      }

      return {
        ...state,
        [payload.parcelCode]: payload,
      };
    case actionTypes.RESET_SELECTED:
      return initialState;

    default:
      return state;
  }
};
